export default __webpack_public_path__ + "static/media/mail.db8c6d0a.svg";